import React, { useState } from 'react';
import { cardTypes } from '../../agentTheme';

/**
 * Renders system-injected messages (auto-analysis prompts, internal context).
 * Hidden by default, shown in dev mode with distinct visual treatment.
 */
export default function SystemMessageCard({ text, devMode }) {
  const [expanded, setExpanded] = useState(false);

  // Hidden entirely when not in dev mode
  if (!devMode) return null;

  // Strip the URO_HIDDEN prefix for display
  const displayText = text.replace(/^\[?URO_HIDDEN\]?\s*/i, '').replace(/^\[System:\s*/i, '').replace(/\]$/, '');

  return (
    <div
      className="smart-card"
      style={{
        background: cardTypes.system.bg,
        border: `1px dashed ${cardTypes.system.border}`,
        cursor: 'pointer',
      }}
      onClick={() => setExpanded(e => !e)}
    >
      <div style={{
        fontSize: 10, fontWeight: 800, letterSpacing: 1.5, textTransform: 'uppercase',
        color: 'rgba(255,255,255,0.15)', marginBottom: 6,
        display: 'flex', alignItems: 'center', gap: 6,
      }}>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
        System
      </div>

      <div style={{
        fontSize: 12, color: 'rgba(255,255,255,0.25)', fontFamily: 'monospace',
        lineHeight: 1.5, whiteSpace: 'pre-wrap', wordBreak: 'break-word',
        maxHeight: expanded ? 'none' : 80, overflow: 'hidden',
      }}>
        {displayText}
      </div>

      {displayText.length > 200 && (
        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.12)', marginTop: 4 }}>
          {expanded ? 'click to collapse' : 'click to expand'}
        </div>
      )}
    </div>
  );
}
